import React, { useState } from 'react';
import {
  Box,
  Tab,
  Tabs,
  Typography,
  Paper,
  Avatar,
  useTheme,
  alpha,
} from '@mui/material';
import {
  AccountTree as AccountTreeIcon,
  Schedule as ScheduleIcon,
  Settings as SettingsIcon,
  WhatsApp as WhatsAppIcon,
  SmartToy as SmartToyIcon,
} from '@mui/icons-material';
import AtendimentoConexoesTab from './AtendimentoConexoesTab';
import AtendimentoConfiguracoesTab from './AtendimentoConfiguracoesTab';
import AtendimentoExpedienteTab from './AtendimentoExpedienteTab';
import AtendimentoSetoresTab from './AtendimentoSetoresTab';
import { FlowBuilder } from '../atendimento/FlowBuilder';

const ParametrosAtendimento: React.FC = () => {
  const [tabAtiva, setTabAtiva] = useState(0);
  const theme = useTheme();
  const primario = theme.palette.primary.main;

  const tabItems = [
    { label: 'Conexões', icon: <WhatsAppIcon />, color: '#25D366' },
    { label: 'Setores', icon: <AccountTreeIcon />, color: theme.palette.primary.main },
    { label: 'Expediente', icon: <ScheduleIcon />, color: '#f57c00' },
    { label: 'Configurações', icon: <SettingsIcon />, color: '#7b1fa2' },
    { label: 'Fluxo Bot', icon: <SmartToyIcon />, color: '#0288d1' },
  ];

  return (
    <Box sx={{ p: 0.5 }}>
      <Paper
        elevation={2}
        sx={{
          mb: 2,
          borderRadius: 2,
          overflow: 'hidden',
          background: `linear-gradient(135deg, ${alpha(primario, 0.04)} 0%, ${alpha(theme.palette.secondary.main, 0.04)} 100%)`,
        }}
      >
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Avatar sx={{ bgcolor: alpha(primario, 0.12), color: primario, width: 40, height: 40 }}>
              <WhatsAppIcon sx={{ fontSize: 22 }} />
            </Avatar>
            <Box>
              <Typography variant="h6" fontWeight={800} sx={{ fontSize: '1.05rem', lineHeight: 1.2 }}>
                Atendimento
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.72rem' }}>
                Configure as conexões, setores e preferências do módulo de atendimento
              </Typography>
            </Box>
          </Box>
        </Box>

        <Tabs
          value={tabAtiva}
          onChange={(_, value) => setTabAtiva(value)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            px: 1,
            borderTop: `1px solid ${theme.palette.divider}`,
            bgcolor: alpha(theme.palette.background.paper, 0.6),
            '& .MuiTab-root': { textTransform: 'none', fontWeight: 600, fontSize: '0.82rem', minHeight: 42, gap: 0.8 },
          }}
        >
          {tabItems.map((item, index) => (
            <Tab
              key={index}
              icon={React.cloneElement(item.icon, {
                sx: { fontSize: 17, color: tabAtiva === index ? item.color : 'text.secondary' },
              })}
              iconPosition="start"
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                  {item.label}
                </Box>
              }
            />
          ))}
        </Tabs>
      </Paper>

      {tabAtiva === 0 && (
        <Box sx={{ p: 1.5 }}>
          <AtendimentoConexoesTab />
        </Box>
      )}
      {tabAtiva === 1 && (
        <Box sx={{ p: 1.5 }}>
          <AtendimentoSetoresTab />
        </Box>
      )}
      {tabAtiva === 2 && (
        <Box sx={{ p: 1.5 }}>
          <AtendimentoExpedienteTab />
        </Box>
      )}
      {tabAtiva === 3 && (
        <Box sx={{ p: 1.5 }}>
          <AtendimentoConfiguracoesTab />
        </Box>
      )}
      {tabAtiva === 4 && (
        <Box sx={{ p: 1.5 }}>
          <FlowBuilder />
        </Box>
      )}
    </Box>
  );
};

export default ParametrosAtendimento;
